import RouteRecognizer from 'route-recognizer';

let router = {
  rr: null,
};

router.rr = new RouteRecognizer();

export default router;
